import { Dispatch } from "redux";

import {
  ReduxHelperStatus,
  ReduxStateObj,
  ReduxStateItem,
  CtxIncludeIo,
  AsyncParamFunc,
  ReduxHelperItemObj,
  ActionFuncResponse,
} from "./types";

export function createAsyncHelper<P = any, V = any, E = any>(
  name: string,
  task: AsyncParamFunc<P, V, E>
): ReduxHelperItemObj {
  if (!name.startsWith("async")) {
    throw new Error(`name(${name}) must starts with 'async'`);
  }
  const action = createAsyncAction(name, task);
  const state = createAsyncState(name);
  const reducer = createAsyncReducer(name);
  return {
    action,
    state,
    reducer,
  };
}

function createAsyncAction<P = any, V = any, E = any>(name: string, task: AsyncParamFunc<P, V, E>) {
  return (param: any) => (
    dispatch: Dispatch<ReduxStateObj<P, V>>,
    getState: () => ReduxStateObj<P, V>,
    extraArgument: CtxIncludeIo
  ): ActionFuncResponse<V> => {
    dispatch({ type: getActionType(name, "START") });
    return Promise.resolve()
      .then(() => {
        return task(param, extraArgument, dispatch, getState);
      })
      .then((data) => {
        return data;
      })
      .then((data) => {
        dispatch({ type: getActionType(name, "COMPLETE"), payload: { param, value: data } });
        return data;
      });
  };
}

const initialState: ReduxStateItem = {
  status: ReduxHelperStatus.INITIAL,
  param: undefined,
  value: undefined,
  isReady: false,
};

function createAsyncState<P = any, V = any>(name: string): ReduxStateObj<P, V> {
  return {
    [name]: {
      ...initialState,
    },
  };
}

function createAsyncReducer<S extends Record<string, any>, P extends Record<string, any>, V>(
  name: string
) {
  return (state: S, action: { type: string; payload?: { param: P; value: V } }): S => {
    switch (action.type) {
      case getActionType(name, "START"):
        return {
          ...state,
          [name]: {
            status: ReduxHelperStatus.LOADING,
            param: undefined,
            value: undefined,
            isReady: false,
          },
        };
      case getActionType(name, "COMPLETE"):
        return {
          ...state,
          [name]: {
            status: ReduxHelperStatus.COMPLETE,
            param: action.payload?.param,
            value: action.payload?.value,
            isReady: true,
          },
        };
      default:
        return state;
    }
  };
}

function getActionType(name: string, type: "START" | "COMPLETE"): string {
  return `${name}:${type}:g2v9t5kwwmn`;
}
